import HttpService from "../services/Http.Service";

async function getBuilding(data) {
    return await HttpService.controlServerWithToken("GET", "building", "get_building", data);
}

async function createBuilding(data) {
    return await HttpService.controlServerWithToken("POST", "building", "create_building", data);
}

async function updateBuilding(data) {
    return await HttpService.controlServerWithToken("POST", "building", "update_building", data);
}

async function deleteBuilding(data) {
    return await HttpService.controlServerWithToken("POST", "building", "delete_building", data);
}

export { getBuilding, createBuilding, updateBuilding, deleteBuilding };
